import { ChevronDownSmall } from "@wix/wix-ui-icons-common";
import React, { forwardRef } from "react";
import { ToolbarButton } from "./toolbar-button/toolbar-button.js";
const DropdownButton = forwardRef(
  ({ icon: Icon, dataHook, tooltip, onClick, active, disabled, ariaControlsId, tabIndex }, ref) => {
    return /* @__PURE__ */ React.createElement(
      ToolbarButton,
      {
        ref,
        tooltip,
        onClick,
        active,
        disabled,
        prefix: Icon,
        suffix: ChevronDownSmall,
        dataHook,
        "aria-haspopup": "true",
        "aria-expanded": active,
        "aria-controls": ariaControlsId,
        tabIndex
      }
    );
  }
);
DropdownButton.displayName = "DropdownButton";
export {
  DropdownButton
};
//# sourceMappingURL=dropdown-button.js.map
